'use client'

import { useState, useEffect } from 'react'
import { Bell, BellOff } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function SoundControl() {
  const [soundEnabled, setSoundEnabled] = useState(true)

  // localStorage에서 초기값 로드
  useEffect(() => {
    const savedState = localStorage.getItem('soundEnabled')
    if (savedState !== null) {
      setSoundEnabled(savedState === 'true')
    }
  }, [])

  // storage 이벤트 리스닝
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'soundEnabled' && e.newValue !== null) {
        setSoundEnabled(e.newValue === 'true')
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  const handleToggleSound = () => {
    const newState = !soundEnabled
    console.log('Toggle sound from', soundEnabled, 'to', newState)
    setSoundEnabled(newState)

    // localStorage에 저장하여 모든 컴포넌트에서 공유
    localStorage.setItem('soundEnabled', newState.toString())

    // 사용자 상호작용 플래그 설정 (벨 버튼 클릭은 사용자 상호작용)
    localStorage.setItem('userInteracted', 'true')

    // 사운드를 켤 때 테스트 사운드 재생
    if (newState) {
      const audio = new Audio('/sounds/alert.mp3')
      audio.volume = 0.3
      audio.play()
        .then(() => {
          console.log('Test sound played successfully')
        })
        .catch(err => {
          console.log('Sound test failed:', err)
        })
    }

    // 다른 탭/창에서도 업데이트되도록 storage 이벤트 수동 발생
    // (같은 탭에서는 storage 이벤트가 자동으로 발생하지 않음)
    window.dispatchEvent(new StorageEvent('storage', {
      key: 'soundEnabled',
      newValue: newState.toString(),
      oldValue: (!newState).toString(),
      storageArea: localStorage,
      url: window.location.href
    }))
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleToggleSound}
      className="relative transition-all duration-200 hover:scale-110"
    >
      {soundEnabled ? (
        <Bell
          className="h-5 w-5 transition-transform duration-300 hover:rotate-12"
          aria-label="알림 켜짐"
        />
      ) : (
        <BellOff
          className="h-5 w-5 text-muted-foreground transition-transform duration-300"
          aria-label="알림 꺼짐"
        />
      )}
      {soundEnabled && (
        <span className="absolute -top-1 -right-1 flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
        </span>
      )}
    </Button>
  )
}